var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"alerts"},[(this.$slots['icon'])?_vm._t("icon"):_vm._e(),_c('p',{staticClass:"alerts__text"},[_vm._t("text")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }